export { getBasePath, getRemotes } from './composition';
export {
  MissingCompositionError,
  MissingScopeError,
  MissingVarsError,
  VarsConflictError,
} from './errors';
export { ANONYMOUS, getIdentity } from './identity';
export type { Identity } from './identity';
export { hasVars, readVars, resetVars, setVars } from './store';
export type { Vars } from './types';
export type {
  AppshellIndex,
  AppshellRemote,
  Metadata,
  ModuleFederationLoader,
  RemoteLoader,
} from './wire';
